import { render, staticRenderFns } from "./dashboardPieChart.vue?vue&type=template&id=b465ee06&"
import script from "./dashboardPieChart.vue?vue&type=script&lang=js&"
export * from "./dashboardPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports